// import { useEffect, useState } from "react";
// import { useLocation } from "react-router-dom";
// import "./single.scss";
// import Sidebar from "../../components/sidebar/Sidebar";
// import Navbar from "../../components/navbar/Navbar";
// import { Link } from "react-router-dom";
// import { serverUrl } from "../../temp";
// const TimeTableSingle = () => {
//   // Extracting timetableId using regular expressions
//   const location = useLocation();
//   // const timetableId = location.pathname.match(/\/class\/(\d+)/);
//   const timetableId = location.pathname.match(/\/time-table\/(\d+)/)?.[1];

//   const [timetable, setTimetable] = useState(null);
//   let [token] = useState(localStorage.getItem("token"));

//   const redirectToLogin = () => {
//     alert("Plaese Login first then you can access this page...");
//     window.location.href = "/"; // Replace "/login" with the actual login page path
//   };

//   const fetchTimeTable = async () => {
//     try {
//       const response = await fetch(`${serverUrl}/timetable/${timetableId}`);
//       // if (!response.ok) {
//       //     throw new Error('Failed to fetch class');
//       // }
//       const data = await response.json();
//       setTimetable(data);
//       localStorage.setItem("lformData", JSON.stringify(data));
//     } catch (error) {
//       console.error(error);
//     }
//   };

//   useEffect(() => {
//     if (timetableId) {
//       fetchTimeTable();
//     }
//   }, [timetableId]);

//   return (
//     <>
//       {!token && redirectToLogin()}
//       {token && (
//         <div className="single">
//           <Sidebar />
//           <div className="singleContainer">
//             <Navbar />
//             <div className="top">
//               <div className="left">
//                 <h1 className="title">Slot Details</h1>
//                 <div className="details">
//                   <h1 className="itemTitle">{timetable?.data.day}</h1>
//                   {/* <div className="detailItem">
//                                             <span className="itemKey">Id: </span>
//                                             <span className="itemValue">{timetable?.data.id}</span>
//                                         </div> */}
//                   {/* <div className="detailItem">
//                                             <span className="itemKey">Center Id: </span>
//                                             <span className="itemValue">{timetable?.data.center_id}</span>
//                                         </div> */}
//                   <div className="detailItem">
//                     <span className="itemKey">Teacher: </span>
//                     <span className="itemValue">{timetable?.data.teacher_names}</span>
//                   </div>
//                   <div className="detailItem">
//                     <span className="itemKey">Subject: </span>
//                     <span className="itemValue">
//                       {timetable?.data.subject_names}
//                     </span>
//                   </div>
//                   <div className="detailItem">
//                     <span className="itemKey">Class: </span>
//                     <span className="itemValue">
//                       {timetable?.data.class_names}
//                     </span>
//                   </div>
//                   {/* <div className="detailItem">
//                                             <span className="itemKey">Time: </span>
//                                             <span className="itemValue">{timetable?.data.time}</span>
//                                         </div> */}
//                   <div className="detailItem">
//                     <span className="itemKey">Start Time: </span>
//                     <span className="itemValue">
//                       {timetable?.data.start_slot_time}
//                     </span>
//                   </div>
//                   <div className="detailItem">
//                     <span className="itemKey">End Time: </span>
//                     <span className="itemValue">
//                       {timetable?.data.end_slot_time}
//                     </span>
//                   </div>
//                   {/* <div className="detailItem">
//                                             <span className="itemKey">Status: </span>
//                                             <span className="itemValue">{timetable?.data.status}</span>
//                                         </div> */}
//                 </div>
//               </div>
//             </div>
//             {/* <div className="right">
//                     <Chart aspect={3 / 1} title="class Spending ( Last 6 Months)" />
//                 </div> */}
//           </div>
//           {/* <div className="bottom">
//                 <h1 className="title">Last Transactions</h1>
//                 <List />
//                 </div> */}
//         </div>
//       )}
//     </>
//   );
// };

// export default TimeTableSingle;



import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { serverUrl } from "../../temp";

const TimeTableSingle = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const timetableId = location.pathname.match(/\/time-table\/(\d+)/)?.[1];
  const [timetable, setTimetable] = useState(null);
  const [token] = useState(localStorage.getItem("token"));
  const [isLoading, setIsLoading] = useState(true);

  const redirectToLogin = () => {
    alert("Please login first to access this page...");
    window.location.href = "/";
  };

  const fetchTimeTable = async () => {
    try {
      const response = await fetch(`${serverUrl}/timetable/${timetableId}`);
      const data = await response.json();
      setTimetable(data);
      localStorage.setItem("timetableData", JSON.stringify(data));
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (timetableId) {
      fetchTimeTable();
    }
  }, [timetableId]);

  if (!token) {
    redirectToLogin();
    return null;
  }

  return (
    <div className="single">
      <Sidebar />
      <div className="singleContainer">
        <Navbar />
        <div className="top">
          <div className="left">
            <div className="flex justify-between items-center mb-4">
              <button
                onClick={() => navigate(-1)}
                className="px-3 py-1 text-sm bg-purple-100 text-purple-800 rounded-lg hover:bg-purple-200 transition-all border border-purple-200 flex items-center gap-1 shadow-sm hover:shadow-md"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-4 w-4"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M10 19l-7-7m0 0l7-7m-7 7h18"
                  />
                </svg>
                Back
              </button>
              <h1 className="title flex-1 text-center">Slot Details</h1>
              <div className="w-20"></div>
            </div>

            {isLoading ? (
              <div className="flex justify-center items-center h-64">
                <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-purple-500"></div>
              </div>
            ) : (
              <div className="space-y-6">
                {/* Timetable Header */}
                <div className="bg-white rounded-xl p-6 shadow-sm">
                  <div className="flex flex-col md:flex-row gap-6 items-center md:items-start">
                    {/* Timetable Icon */}
                    <div className="flex-shrink-0">
                      <div className="w-20 h-20 md:w-24 md:h-24 rounded-full bg-purple-100 flex items-center justify-center">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-10 w-10 text-purple-600"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                          />
                        </svg>
                      </div>
                    </div>

                    {/* Timetable Info */}
                    <div className="flex-1 text-center md:text-left">
                      <h1 className="text-2xl font-bold text-gray-800 mb-3">
                        {timetable?.data.day}
                      </h1>
                      
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
                        {timetable?.data.teacher_names && (
                          <div className="bg-gray-50 rounded-lg p-3">
                            <span className="text-gray-500 block">Teacher:</span>
                            <span className="font-medium">{timetable.data.teacher_names}</span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Class Information */}
                <div className="bg-white rounded-xl p-6 shadow-sm">
                  <h3 className="text-lg font-medium text-gray-800 mb-4 border-b pb-2">
                    Class Information
                  </h3>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {timetable?.data.class_names && (
                      <div>
                        <label className="block text-sm text-gray-500 mb-2">Class</label>
                        <p className="text-gray-800 bg-gray-50 rounded-lg p-3">
                          {timetable.data.class_names}
                        </p>
                      </div>
                    )}
                    
                    {timetable?.data.subject_names && (
                      <div>
                        <label className="block text-sm text-gray-500 mb-2">Subject</label>
                        <p className="text-gray-800 bg-gray-50 rounded-lg p-3">
                          {timetable.data.subject_names}
                        </p>
                      </div>
                    )}
                  </div>
                </div>

                {/* Time Slot */}
                <div className="bg-white rounded-xl p-6 shadow-sm">
                  <h3 className="text-lg font-medium text-gray-800 mb-4 border-b pb-2">
                    Time Slot
                  </h3>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {timetable?.data.start_slot_time && (
                      <div>
                        <label className="block text-sm text-gray-500 mb-2">Start Time</label>
                        <p className="text-gray-800 bg-gray-50 rounded-lg p-3">
                          {timetable.data.start_slot_time}
                        </p>
                      </div>
                    )}
                    
                    {timetable?.data.end_slot_time && (
                      <div>
                        <label className="block text-sm text-gray-500 mb-2">End Time</label>
                        <p className="text-gray-800 bg-gray-50 rounded-lg p-3">
                          {timetable.data.end_slot_time}
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TimeTableSingle;